import { FC } from 'react';

import { AcademicYearTitle } from 'components/pdfStudent';
import { splitDataWithUnformattedEventDate } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionProforientationApplications } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { proforientationApplicationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { getDataLoadRequests } from 'utils';

import PdfCommonDataEntityContainer from '../common';
import ApplicationExcursions from './applications/ApplicationExcursions';
import ApplicationOpenDays from './applications/ApplicationOpenDays';
import ApplicationsProbes from './applications/ApplicationProbes';

const PdfApplications: FC = () => {
  useDataLoad({
    shouldLoad: true,
    requests: getDataLoadRequests().professionProforientationRecommendationApplications,
  });

  const academicYears = useAppSelector(chosenAcademicYearsListSelector);

  const excursions = useAppSelector(proforientationApplicationSelectors.excursions);
  const probes = useAppSelector(proforientationApplicationSelectors.probes);
  const dods = useAppSelector(proforientationApplicationSelectors.dods);

  const hasData = excursions.length !== 0 || dods.length !== 0 || probes.length !== 0;

  const excursionsAcademicYearData = splitDataWithUnformattedEventDate(excursions, academicYears);
  const probesAcademicYearData = splitDataWithUnformattedEventDate(probes, academicYears);
  const dodsAcademicYearData = splitDataWithUnformattedEventDate(dods, academicYears);

  const yearsList = new Set([
    ...excursionsAcademicYearData.map(([year, _]) => year),
    ...probesAcademicYearData.map(([year, _]) => year),
    ...dodsAcademicYearData.map(([year, _]) => year),
  ]);

  return (
    <PdfCommonDataEntityContainer title="Заявки" Icon={IconWidgetProfessionProforientationApplications}>
      {hasData &&
        Array.from(yearsList).map((academicYear) => {
          const excursionsData = excursionsAcademicYearData.find(([year, _]) => year === academicYear);
          const probesData = probesAcademicYearData.find(([year, _]) => year === academicYear);
          const dodsData = dodsAcademicYearData.find(([year, _]) => year === academicYear);

          if (!excursionsData && !probesData && !dodsData) {
            return null;
          }

          return (
            <div key={academicYear}>
              <AcademicYearTitle academicYear={academicYear} />
              {probesData && <ApplicationsProbes data={probesData[1]} />}
              {excursionsData && <ApplicationExcursions data={excursionsData[1]} />}
              {dodsData && <ApplicationOpenDays data={dodsData[1]} />}
            </div>
          );
        })}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfApplications;
